import { Component, OnInit, Input } from '@angular/core';
import { MainPageService } from '../../../main-page.service';
import { SystemModel } from '../../../../models/dictionaries/system.model';
import { CorosiveProtectionModel } from '../../../../models/dictionaries/corosive-protection.model';
import { UniversalConnectorModel, ConnectorType } from '../../../../models/parts/universal-connector.model';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { PipeFasteningsManagmentComponent } from '../../../../main-page/master-data/pipe-fastening/pipe-fastening-managment/pipe-fastening-managment.component';

declare var $: any;

@Component({
  selector: 'app-pipe-fastenings-grid',
  template: `<!-- <div [hidden]="isConnectorHidden">
    <hc-data-grid id="mainGrid" (onAddClick)="addConnector()" [data]="myArray" [select]="false" [headers]="headers" [subheader]="true" [displayedColumns]="displayedColumns" (onEditClick)="onConnectorClick($event)">
    </hc-data-grid>
</div> -->

<!-- Edit Modal -->
<div class="modal" id="addPipeFasteningModal">
    <div class="modal-dialog">
        <div class="form">
            <form class="form-group" [formGroup]="formGroup">
                <div class="modal-content">

                    <!-- Modal Header -->
                    <div class="modal-header">
                        <button type="button" class="close" data-dismiss="modal">&times;</button>
                    </div>

                    <!-- Modal body -->
                    <div class="modal-body display-flex">
                        <div>
                            <div>
                                <div class="display-flex">
                                    <span class="modal-label">Article no:</span>
                                    <input type="number" formControlName="articleNumber" [(ngModel)]="templatePipeFastening.articleNumber">
                                </div>
                                <div class="display-flex">
                                    <span class="modal-label">Name:</span>
                                    <input type="text" [(ngModel)]="templatePipeFastening.name" formControlName="name">
                                </div>
                                <div class="display-flex">
                                    <span class="modal-label">Description:</span>
                                    <input type="text" [(ngModel)]="templatePipeFastening.description" formControlName="description">
                                </div>
                                <div class="display-flex">
                                    <span class="modal-label">System:</span>
                                    <select name="systemSelect" class="selectHeight" [(ngModel)]="templatePipeFastening.system" formControlName="system">
                                        <option *ngFor="let system of systemsArray | sortByName" [ngValue]="system.name">{{system.name}}</option>
                                    </select>
                                </div>
                                <div class="display-flex">
                                    <span class="modal-label">Corrosion protection:</span>
                                    <select name="corrProtSelect" class="selectHeight" formControlName="corrosionProtection" [(ngModel)]="templatePipeFastening.corrosionProtection">
                                        <option *ngFor="let corrosionProtection of corrosionProtectionsArray | sortByName" [ngValue]="corrosionProtection.name">{{corrosionProtection.name}}</option>
                                    </select>
                                </div>
                                <div class="display-flex">
                                    <span class="modal-label">Group:</span>
                                    <select name="fasteningGroupSelect" class="selectHeight" formControlName="pipeFasteningGroupId" [(ngModel)]="templatePipeFastening.pipeFasteningGroupId">
                                        <option *ngFor="let fasteningGroup of pipeFasteningGroupsArray | sortByName" [ngValue]="fasteningGroup.id">{{fasteningGroup.name}}</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- Modal footer -->
                    <div class="modal-footer">
                        <button type="button" class="btn btn-danger red-button" data-dismiss="modal">Cancel</button>
                        <button type="submit" class="btn btn-primary save-button" data-dismiss="modal" [disabled]="formGroup.invalid" (click)="saveNewPipeFastening()">Save</button>
                    </div>
                </div>
            </form>
        </div>
    </div>
</div>

<div class="input-effect">
    <input id="searchInput" class="effect1 search-input" type="text" placeholder="" (keyup)="searchInGridData()">
    <label>Search</label>
    <span class="focus-border"></span>
</div>
<button class="red-button" type="button" data-toggle="modal" data-target="#addPipeFasteningModal" (click)="prepareCreate()">Create</button>

<div class="table-wrapper">
    <div class="table-scroll">
        <table>
            <tr>
                <th *ngFor="let header of headers">{{header}}</th>
            </tr>
            <tr *ngFor="let pipeFastening of pipeFasteningsGridData,let row_no = index" (click)="onRowClick(row_no,pipeFastening._id)" style="cursor:pointer" [class.highlighted]="pipeFastening._id === selectedRowId">
                <td class="column-width">{{pipeFastening.articleNumber}}</td>
                <td class="column-width">{{pipeFastening.name}}</td>
            </tr>
        </table>
    </div>
</div>`,
  styles: [`table{font-family:arial,sans-serif;border-collapse:collapse;width:100%}td,th{border:1px solid #ddd;text-align:left;padding:8px}tr:nth-child(even){background-color:#ddd}.modal-label{width:168px}.display-flex{display:flex;align-items:center;margin-bottom:10px}.search-input{border:none;border-bottom:1px solid gray;outline:0;margin-right:10px}.highlighted{background-color:#534f53!important;color:#fff}`]
})
export class PipeFasteningsGridComponent implements OnInit {
  @Input() pipeFasteningComponent: PipeFasteningsManagmentComponent;
  isPipeFasteningHidden = true;
  pipeFasteningsGridData: UniversalConnectorModel[] = [];
  pipeFasteningsGridDataOrigin: UniversalConnectorModel[] = [];
  templatePipeFastening = new UniversalConnectorModel(ConnectorType.PipeFastening);
  public selectedRowId;
  public systemsArray: SystemModel[] = [];
  public corrosionProtectionsArray: CorosiveProtectionModel[] = [];
  public pipeFasteningGroupsArray: any[] = [];
  public formGroup: FormGroup;

  headers: string[] = ['Article no.', 'Name'];
  constructor(private mainPageService: MainPageService) {}

  public ngOnInit(): void {
    this.loadData();
    // this.mainPageService.mysubject.subscribe( (value) => {
    //   this.updatePipeFasteningsInDb(value);
    //   this.pipeFasteningsGridData.sort((n1, n2) => Number(n1.articleNumber) > Number(n2.articleNumber) ? 1 : -1);
    // });
    this.mainPageService.deleteUniversalConnectorSubject.subscribe( (value) => {
      this.pipeFasteningsGridData = this.pipeFasteningsGridData.filter(x => x._id !== value);
      this.pipeFasteningsGridData.sort((n1, n2) => Number(n1.articleNumber) > Number(n2.articleNumber) ? 1 : -1);
    });
    this.createForm();
  }


  loadData(): void {
    this.mainPageService.loadAllSystems().subscribe((response) => {
      this.systemsArray = response;
    });
    this.mainPageService.loadAllCorosionProtections().subscribe((response) => {
      this.corrosionProtectionsArray = response;
    });
    this.mainPageService.loadSpecificConnectors(ConnectorType.PipeFastening).subscribe((response) => {
      this.pipeFasteningsGridData = response;
      this.pipeFasteningsGridDataOrigin = response;
      this.pipeFasteningsGridData.sort((n1, n2) => Number(n1.articleNumber) > Number(n2.articleNumber) ? 1 : -1);
      this.pipeFasteningsGridDataOrigin.sort((n1, n2) => Number(n1.articleNumber) > Number(n2.articleNumber) ? 1 : -1);
    });
    this.mainPageService.loadAllPipeFasteningGroups().subscribe((response) => {
      this.pipeFasteningGroupsArray = response;
    });
   }

  toggle() {
    const actionButtons = $('.mat-icon-button');
    $(actionButtons[1]).css('visibility', 'hidden');
    for (let i = 2; i < actionButtons.length; i += 2) {
        $(actionButtons[i]).css('visibility', 'hidden');
    }
    this.isPipeFasteningHidden = !this.isPipeFasteningHidden;
  }

  onbasesClick(sender) {
    this.pipeFasteningComponent.showPipeFastening(sender);
  }

  onRowClick(row, id) {
    this.selectedRowId = id;
    this.pipeFasteningComponent.showPipeFastening(this.pipeFasteningsGridData[row]);
  }

  updatePipeFasteningsInDb(id) {
    let dataToSend;
    let preparedData;
    for (const item of this.pipeFasteningsGridData) {
      if (item._id === id) {
        dataToSend = item;
        break;
      }
    }
    for (const item of this.pipeFasteningsGridData) {
      if (item._id === id) {
         preparedData = item;
        break;
      }
    }
    preparedData.articleNumber = dataToSend.articleNumber;
    preparedData.description = dataToSend.description;
    preparedData.name = dataToSend.name;
    this.mainPageService.updateUniversalConnectorInDb(JSON.stringify(preparedData)).subscribe(() => { });
    this.pipeFasteningsGridData.sort((n1, n2) => Number(n1.articleNumber) > Number(n2.articleNumber) ? 1 : -1);
  }

  saveNewPipeFastening() {
    this.mainPageService.addNewUniversalConnectorIntoDb(JSON.stringify(this.templatePipeFastening)).subscribe((response) => {
      this.templatePipeFastening._id = response;
      this.pipeFasteningsGridData.push(this.templatePipeFastening);
      this.templatePipeFastening = new UniversalConnectorModel(ConnectorType.PipeFastening);
      this.pipeFasteningsGridData.sort((n1, n2) => Number(n1.articleNumber) > Number(n2.articleNumber) ? 1 : -1);
    });
  }

  searchInGridData() {
    const inputValue = (<HTMLInputElement>document.getElementById('searchInput')).value;
    this.pipeFasteningsGridData = this.pipeFasteningsGridDataOrigin;
    if ( inputValue !== '') {
      this.pipeFasteningsGridData  = this.pipeFasteningsGridData.filter(x => x.name.toLowerCase().indexOf(inputValue.toLowerCase()) >= 0
      || (x.articleNumber.toString().indexOf(inputValue) >= 0));
    }
  }

  public prepareCreate() {
    this.templatePipeFastening = new UniversalConnectorModel(ConnectorType.PipeFastening);
    this.createForm();
  }

  private createForm() {
    this.formGroup = new FormGroup({
      name: new FormControl(this.templatePipeFastening.name, Validators.required),
      articleNumber: new FormControl(this.templatePipeFastening.articleNumber),
      description: new FormControl(this.templatePipeFastening.description),
      system: new FormControl(this.templatePipeFastening.system, Validators.required),
      corrosionProtection: new FormControl(this.templatePipeFastening.corrosionProtection, Validators.required),
      pipeFasteningGroupId: new FormControl(this.templatePipeFastening.corrosionProtection, Validators.required),
    });
  }

}
